import { AccountRelationsDetailsApiDtoClm } from 'types/BusinessRelationship';
import { ACCOUNT_RELATIONS_BACKEND_URL } from 'services/constants';
import { axiosInstance } from '../shared/axios/axiosConfig';

const getBusinessRelationship = async (brUid: string): Promise<AccountRelationsDetailsApiDtoClm> => {
  const request = axiosInstance.get(
    `${ACCOUNT_RELATIONS_BACKEND_URL}/api/internal/v1/business-relationships/${brUid}?withPartnerInfo=true&withPartnerProfileInfo=false`,
    {},
  );
  const response = await request;
  return response.data;
};

const brService = { getBusinessRelationship };
export default brService;
